<template>
  <div class="RecentScan">
    <h3 :style="{marginLeft: union_isBilingual ? '-20px' : ''}">
      {{TLang('最近浏览','list')}}
    </h3>
    <div class="carousel-content">
      <Carousel
        :autoplay="false"
        arrow="none"
        direction="vertical"
        :height="list[activeIndex].length === 5 ? 350*5+ 'px' : 350* list[activeIndex].length+ 'px'"
        @change="onChange"
      >
        <CarouselItem
          v-for="(item,index) in list"
          :key="index"
        >
          <div>
            <div
              v-for="goods in item"
              :key="goods.id"
            >
              <Goodsitem
                :goods="goods"
                :purchaseType="2"
                :onClick="toDetail"
                :restock="false"
              />
            </div>
          </div>
        </CarouselItem>
      </Carousel>
      <div
        v-if="list.length > 1"
        class="switch"
      >
        <div @click="onSwitchDown">
          <svg
            t="1582869535024"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3715"
            width="32"
            height="32"
          ><path
            d="M512 641.009L181.236 301.935c-12.179-12.485-31.924-12.485-44.102 0-12.179 12.484-12.179 32.725 0 45.21L512 731.429l374.866-384.284c12.179-12.485 12.179-32.726 0-45.21-12.178-12.485-31.923-12.485-44.102 0L512 641.009z"
            fill="#666666"
            p-id="3716"
          ></path></svg>
        </div>
        <div @click="onSwitchUp">
          <svg
            t="1582869422690"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3476"
            width="32"
            height="32"
          ><path
            d="M512 382.991L181.236 722.065c-12.179 12.485-31.924 12.485-44.102 0-12.179-12.484-12.179-32.725 0-45.21L512 292.571l374.866 384.284c12.179 12.485 12.179 32.726 0 45.21-12.178 12.485-31.923 12.485-44.102 0L512 382.991z"
            fill="#666666"
            p-id="3477"
          ></path></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel , CarouselItem} from 'element-ui';
import Goodsitem from './../../../lifeIndex/GoodsItem';
export default {
  name: 'RecentScan',
  components: { Carousel, CarouselItem, Goodsitem },
  props: {
    list: {
      type: Array,
      default: function(){
        return [];
      },
    },
  },
  data(){
    return {
      activeIndex: 0,
    };
  },
  methods: {
    onChange(index){
      this.activeIndex = index;
    },
    toDetail(goods){
      window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    onSwitchDown(){
      this.$children[0].prev();
      window.scrollTo(0,870);
    },
    onSwitchUp(){
      this.$children[0].next();
      window.scrollTo(0,870);
    },
  },
};
</script>

<style lang="less">
  .RecentScan{
    h3{
        font-size: 24px;
        color: #333333;
        border-bottom: 1px solid #b2b2b2;
        line-height: 50px;
        white-space: nowrap;
    }
    .GoodsItem{
      margin: 16px auto;
    }
    .switch{
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 0 30px;
      &:hover{
        cursor: pointer;
      }
    }
  }
</style>